export default __webpack_public_path__ + "static/media/flag-fi.815e63de.svg";